var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('workplace-material-company-list',{ref:"fieldSection",attrs:{"list":_vm.fieldList,"showDetail":true},on:{"select":_vm.handleSelectField}}),_c('company-company-list',{ref:"companySelection",attrs:{"list":_vm.companyList}}),_c('company-user-auth-module',{attrs:{"title":"시스템 사용자 정보","users":_vm.users,"type":"info"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }